import { render } from "./ToolkitPage.vue?vue&type=template&id=deb35504"
import script from "./ToolkitPage.vue?vue&type=script&lang=js"
export * from "./ToolkitPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__